/* Luperro – pretraga uživo (dok kupac kuca) i pretraga po notama */
(function () {
  "use strict";
  var root = document.querySelector("[data-lup-search]");
  if (!root) return;
  var input = root.querySelector("[data-lup-search-input]");
  var list = root.querySelector("[data-lup-search-results]");
  var status = root.querySelector("[data-lup-search-status]");
  var allLink = root.querySelector("[data-lup-search-all]");
  var notes = root.querySelector("[data-lup-search-notes]");
  var form = root.querySelector("form");
  var suggestUrl = root.getAttribute("data-suggest-url") || "/search/suggest";
  var searchUrl = root.getAttribute("data-search-url") || "/search";
  var moneyFormat = root.getAttribute("data-money-format") || "{{amount_with_comma_separator}} KM";
  var T = {
    loading: root.getAttribute("data-t-loading") || "Tražim…",
    none: root.getAttribute("data-t-none") || "Nema parfema za ovu pretragu. Probajte drugu notu ili naziv.",
    from: root.getAttribute("data-t-from") || "od"
  };
  var FIELDS = "title,vendor,product_type,tag,variants.title,body";
  // Ako kupac kuca bez kvačica ili puni naziv note, pretvori u korijen riječi
  var ALIASES = {
    mosus: "mošus", paculi: "pačuli", ruza: "ruž", ruze: "ruž", koza: "kož", koze: "kož",
    vanilija: "vanil", vanilije: "vanil", vanila: "vanil", vanile: "vanil", lavanda: "lavand", lavande: "lavand",
    ambra: "ambr", tonka: "tonk", kafa: "kaf", kafe: "kaf", kava: "kav", kave: "kav",
    drvenasto: "drven", drvenaste: "drven", drvenast: "drven"
  };
  var timer = null;
  var token = 0;
  var cache = {};

  function normalize(s) {
    return (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  function prepare(q) {
    var words = (q || "").trim().split(/\s+/).filter(Boolean);
    if (!words.length) return "";
    var last = normalize(words[words.length - 1]);
    if (ALIASES[last]) words[words.length - 1] = ALIASES[last];
    return words.join(" ");
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return "";
    var fixed = n.toFixed(2);
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key.indexOf("no_decimals") !== -1) return String(Math.round(n));
      if (key.indexOf("comma") !== -1) return fixed.replace(".", ",");
      return fixed;
    });
  }

  function fullUrl(q) {
    return searchUrl + "?q=" + encodeURIComponent(q) + "&type=product&options%5Bprefix%5D=last&options%5Bfields%5D=" + FIELDS;
  }

  function open(e) {
    if (e) e.preventDefault();
    root.hidden = false;
    document.documentElement.classList.add("lup-search-open");
    setTimeout(function () { input.focus(); }, 30);
  }

  function close() {
    root.hidden = true;
    document.documentElement.classList.remove("lup-search-open");
  }

  function reset() {
    list.innerHTML = "";
    status.textContent = "";
    allLink.hidden = true;
    notes.hidden = false;
  }

  function render(products, q) {
    allLink.href = fullUrl(q);
    if (!products.length) {
      list.innerHTML = "";
      status.textContent = T.none;
      allLink.hidden = true;
      return;
    }
    status.textContent = "";
    list.innerHTML = products.map(function (p) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
      if (img) img += (img.indexOf("?") === -1 ? "?" : "&") + "width=120";
      var min = p.price_min != null ? p.price_min : p.price;
      var multi = p.price_max != null && parseFloat(p.price_max) > parseFloat(min);
      return '<li class="lup-search__item"><a href="' + esc(p.url) + '">' +
        (img ? '<img src="' + esc(img) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="lup-search__ph"></span>') +
        '<span>' + (p.vendor ? '<span class="lup-search__vendor">' + esc(p.vendor) + '</span>' : '') +
        '<span class="lup-search__title">' + esc(p.title) + '</span></span>' +
        '<span class="lup-search__price">' + (multi ? esc(T.from) + ' ' : '') + esc(money(min)) + '</span></a></li>';
    }).join("");
    allLink.hidden = false;
  }

  function run(raw) {
    var q = prepare(raw);
    var t = ++token;
    if (normalize(q).length < 2) {
      reset();
      return;
    }
    notes.hidden = true;
    if (cache[q]) {
      render(cache[q], q);
      return;
    }
    status.textContent = T.loading;
    var url = suggestUrl + ".json?q=" + encodeURIComponent(q) +
      "&resources%5Btype%5D=product&resources%5Blimit%5D=8" +
      "&resources%5Boptions%5D%5Bunavailable_products%5D=last" +
      "&resources%5Boptions%5D%5Bfields%5D=" + FIELDS;
    fetch(url, { headers: { Accept: "application/json" } })
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      })
      .then(function (data) {
        if (t !== token) return;
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        cache[q] = products;
        render(products, q);
      })
      .catch(function () {
        if (t !== token) return;
        list.innerHTML = "";
        status.textContent = "";
        allLink.href = fullUrl(q);
        allLink.hidden = false;
      });
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-lup-search-open]")) {
      open(e);
      return;
    }
    if (e.target.closest("[data-lup-search-close]")) {
      close();
      return;
    }
    var chip = e.target.closest("[data-lup-note]");
    if (chip && root.contains(chip)) {
      input.value = chip.textContent.trim();
      run(chip.getAttribute("data-lup-note"));
      input.focus();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !root.hidden) close();
  });

  input.addEventListener("input", function () {
    clearTimeout(timer);
    timer = setTimeout(function () { run(input.value); }, 220);
  });

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var q = prepare(input.value);
    if (q) window.location.href = fullUrl(q);
  });
})();
